export const weekdayKeys = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"]

export const detailChartColors = { two: "#F97316", one: "#00D2D3", curr: "#2D31FA" }

export const getLegends = (lang) => [
  {
    order: 1,
    id: "two",
    label: { ko: "2개월 전", en: "2 Months Ago", es: "Hace 2 meses" }[lang],
    gradient: "from-[#FB923C] to-[#FFF7ED]"
  },
  {
    order: 2,
    id: "one",
    label: { ko: "1개월 전", en: "1 Month Ago", es: "Hace 1 mes" }[lang],
    gradient: "from-[#00D2D3] to-[#CCF6F6]"
  },
  {
    order: 3,
    id: "curr",
    label: { ko: "이번 달", en: "This Month", es: "Este mes" }[lang],
    gradient: "from-[#2D31FA] to-[#E1E2FA]"
  }
]

export const weekdayBundle = {
  title: {
    ko: "요일별 {resource} 사용 패턴 비교",
    en: "{resource} Usage Pattern by Day of Week",
    es: "Comparacion del patron de uso de {resource} por dia de la semana"
  },
  detailButton: { ko: "상세 분석", en: "Detailed Analysis", es: "Analisis detallado" },
  compareLegend: {
    my: { ko: "우리집", en: "My Unit", es: "Mi unidad" },
    dongAverage: { ko: "동 평균", en: "Building Avg", es: "Promedio del edificio" },
    aptAverage: { ko: "단지 평균", en: "Complex Avg", es: "Promedio del complejo" }
  },
  days: {
    sun: { ko: "일", en: "Sun", es: "Dom" },
    mon: { ko: "월", en: "Mon", es: "Lun" },
    tue: { ko: "화", en: "Tue", es: "Mar" },
    wed: { ko: "수", en: "Wed", es: "Mie" },
    thu: { ko: "목", en: "Thu", es: "Jue" },
    fri: { ko: "금", en: "Fri", es: "Vie" },
    sat: { ko: "토", en: "Sat", es: "Sab" }
  },
  detailModal: {
    title: {
      ko: "요일별 상세 주간별 사용 흐름",
      en: "Detailed Weekly Usage Flow by Day of Week",
      es: "Flujo detallado de uso semanal por dia de la semana"
    },
    period: { ko: "분석 기간:", en: "Analysis Period:", es: "Periodo de analisis:" },
    current: { ko: "이번 달 ({period})", en: "This Month ({period})", es: "Este mes ({period})" },
    previous: {
      ko: "1개월 전 ({period})",
      en: "1 Month Ago ({period})",
      es: "Hace 1 mes ({period})"
    },
    twoMonth: {
      ko: "2개월 전 ({period})",
      en: "2 Months Ago ({period})",
      es: "Hace 2 meses ({period})"
    },
    loading: {
      ko: "데이터를 불러오는 중입니다...",
      en: "Loading data...",
      es: "Cargando datos..."
    },
    daySuffix: { ko: "요일", en: "", es: "" },
    weekHeader: { ko: "주차", en: "Week", es: "Semana" },
    total: { ko: "합계", en: "Total", es: "Total" },
    monthLegend: {
      current: { ko: "이번 달", en: "This Month", es: "Este mes" },
      previous: { ko: "1개월 전", en: "1 Month Ago", es: "Hace 1 mes" },
      twoMonth: { ko: "2개월 전", en: "2 Months Ago", es: "Hace 2 meses" }
    },
    weekLegend: {
      format: { ko: "{week}주차", en: "Week {week}", es: "Semana {week}" }
    }
  }
}
